import { examAdminExecutionAttackDefense } from "./exam-admin-execution-attack-defense";

export const examAdminExecution = {
  pageTitle: "CTF環境管理",
  submissions: "コード提出記録",
  pageSubtitle:
    "環境インスタンス、攻防問題の実行状態、プログラミング問題の判定提出をまとめて確認できます。",
  submissionsPageSubtitle:
    "プログラミング問題の判定提出記録と管理者の試運転記録をまとめて確認できます。",
  submissionDetailDefault: "提出詳細",
  submissionDetailTryRun: "提出詳細 {id}",
  submissionDetailRecord: "提出詳細 #{id}",
  attackDefensePanel: examAdminExecutionAttackDefense,
  sections: {
    environments: "環境インスタンス",
    submissions: "コード提出記録",
  },
  stats: {
    environmentTotal: "環境インスタンス総数：{count}",
    environmentActive: "アクティブ環境：{count}",
    environmentAnomaly: "環境異常：{count}",
    submissionTotal: "コード提出総数：{count}",
    submissionAccepted: "Accepted：{count}",
    submissionNonAccepted: "Accepted 以外：{count}",
  },
  filters: {
    activeOnly: "アクティブ環境のみ",
    anomalyOnly: "実行状態異常のみ",
    status: "状態で絞り込み",
    exam: "試験で絞り込み",
    candidate: "受験者で絞り込み",
    nonAcceptedOnly: "Accepted 以外のみ",
    verdict: "verdict で絞り込み",
  },
  actions: {
    viewAttempt: "受験を表示",
    recycleInstance: "インスタンスを回収",
    rejudge: "再判定",
    batchRecycle: "選択したインスタンスを一括回収",
    exportEnvironments: "現在の環境結果をエクスポート",
    exportSubmissions: "現在の提出結果をエクスポート",
    batchRejudge: "選択した問題を一括再判定",
  },
  messages: {
    instanceDestroySubmitted: "環境インスタンスの破棄リクエストを送信しました",
    batchDestroySubmissionPartial: "環境インスタンス破棄リクエストを {submitted} 件送信しました。失敗：{failed} 件",
    batchDestroySubmissionSuccess: "環境インスタンス破棄リクエストを {count} 件送信しました",
    rejudgeSuccess: "再判定が完了しました",
    batchRejudgePartial: "一括再判定が完了しました。成功 {success} 件、失敗 {failed} 件",
    batchRejudgeSuccess: "一括再判定が完了しました。合計 {count} 件",
  },
  confirm: {
    recycleTitle: "この環境インスタンスを回収しますか？",
    recycleDescription: "回収後、実行状態は destroyed に切り替わります。",
    recycleSubmit: "回収",
    batchRecycleTitle: "選択した環境インスタンスを一括回収しますか？",
    batchRecycleDescription: "destroyed ではないインスタンスのみ回収します。",
    batchRecycleSubmit: "一括回収",
    batchRejudgeTitle: "選択した問題を一括再判定しますか？",
    batchRejudgeDescription: "attempt_question で重複排除し、最新の判定結果を再生成します。",
    batchRejudgeSubmit: "一括再判定",
  },
  table: {
    instanceId: "インスタンス ID",
    examAttempt: "試験 / 受験",
    question: "問題",
    types: "タイプ",
    source: "ソース",
    questionVersionCode: "問題バージョン番号",
    runStatus: "実行状態",
    caseResult: "ケース結果",
    operator: "操作ユーザー",
    language: "言語",
    memory: "実行メモリ",
    time: "実行時間",
    action: "操作",
    case: "ケース",
    input: "入力",
    expectedOutput: "期待出力",
    actualOutput: "実際の出力",
    errorInfo: "エラー情報",
    timeUsedMs: "所要時間(ms)",
    memoryUsedMb: "メモリ(MB)",
    providerRef: "プロバイダー参照",
    submissionId: "提出 ID",
    languageAndCount: "言語 / 回数",
    judgeStatus: "判定状態",
    submittedAt: "提出時間",
    questionMeta: "Q#{questionId} / 第 {order} 問 / 受験者 #{candidateId}",
    examLabel: "試験 #{id}",
    attemptLabel: "受験 #{id}",
    candidateLabel: "受験者 #{id}",
    adminTryRun: "試運転",
    unknown: "不明",
    contractValueMissing: "欠落",
    sourceTypeContractAnomaly: "ソース種別の契約異常：{value}",
    flagModeContractAnomaly: "Flag モードの契約異常：{value}",
    acceptedSummary: "{passed} 件通過 / {failed} 件未通過",
    codeSnapshot: "提出コード",
    caseResults: "ケース結果",
    runSuccess: "実行成功",
    runFailed: "実行失敗",
    runRunning: "実行中",
    runStatusContractAnomaly: "実行状態の契約異常：{value}",
    runVerdictContractAnomaly: "実行結果の契約異常：{value}",
    caseAccepted: "通過",
    caseFailed: "失敗",
    caseStatusContractAnomaly: "ケース状態の契約異常：{value}",
  },
};
